import {z} from '@hono/zod-openapi';

export const importHondaPartsPriceListResponseSchema = z
  .object({
    messageId: z.string().openapi({example: 'a1b2c3d4-...'}),
  })
  .openapi('ImportHondaPartsPriceListResponse');

export type ImportHondaPartsPriceListResponse = z.infer<
  typeof importHondaPartsPriceListResponseSchema
>;
